import React, { useEffect, useState } from "react";
import { Table, Button } from "react-bootstrap";
import Layout from "../../components/Layout";
import ToastFile from "../../utils/ToastFile";
import { useRef } from "react";
import { getAllContacts } from "../../api/contactApi";
import moment from "moment";

const Enquiry = () => {
  const [contacts, setcontacts] = useState([]);
  const fetched = useRef(false);

  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;
    getContacts();
  }, []);

  const getContacts = () => {
    getAllContacts()
      .then((res) => {
        if (res.status === 200) {
          setcontacts(res?.data?.data?.contacts);
        } else {
          ToastFile("Failed to fetch contacts", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching contacts:", err);
        ToastFile("Error fetching contacts", "error");
      });
  };

  return (
    <Layout>
      <div className="d-flex justify-content-between align-items-center mb-3">
         <span
            style={{
              fontSize: "22px",
              fontWeight: 600,
              minWidth: "140px",
            }}
          >
            Software Enquiry
          </span>
      </div>
      <Table striped bordered hover responsive>
        <thead className="table-dark">
          <tr style={{ textAlign: 'center' }}>
            <th>Name</th>
            <th>Contact No</th>
            <th>Email</th>
            <th>Company Name</th>
            <th>Country</th>
            <th>Requirements</th>
            <th>Date of Enquiry</th>
            {/* <th>Action</th> */}
          </tr>
        </thead>
        <tbody>
          {contacts.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center">
                No contacts found
              </td>
            </tr>
          ) : (
            contacts.map((c, idx) => (
              <tr key={idx}>
                <td>{c.name}</td>
                <td>{c.contact_no}</td>
                <td>{c.email}</td>
                <td>{c.companyName}</td>
                <td>{c.country}</td>
                 <td>{c.requirements}</td>
                <td>{moment(c.createdAt).format("DD/mm/yyyy")}</td>
                
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </Layout>
  );
};

export default Enquiry;
